import { render, staticRenderFns } from "./changeRecord.vue?vue&type=template&id=5f63aaa9&scoped=true&"
import script from "./changeRecord.vue?vue&type=script&lang=ts&"
export * from "./changeRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63aaa9",
  null
  
)

export default component.exports